import React from 'react';

//styles
import { FormGroup } from 'components/styled/Form.styled';

export const SingleMultipleLayout = ({ multiple, children, mb, width }) => (
  <>
    {multiple ? (
      children
    ) : (
      <FormGroup mb={mb} width={width}>
        {children}
      </FormGroup>
    )}
  </>
);
